module.exports = __webpack_public_path__ + "static/media/DSfees.c4e55f5e.svg";